// @ts-strict

import { Component, Input, OnInit } from '@angular/core';
import { IDomain } from '@app/core/services/content-locker/content-locker.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentLockerService } from '@services/content-locker/content-locker.service';
import { AvailableCodeOption, CodesModalService } from './codes-modal.service';

export interface ICodesParams {
  domain_id: number;
  adblock_detection: number;
  javascript_disabled_detection: number;
  javascript_dynamic_options: number;
  tracking_parameters: number;
  auto_translation: number;
  title: string;
  title_mobile: string;
  desc: string;
  desc_mobile: string;
  ml_sub1: string;
  ml_sub2: string;
  ml_sub3: string;
  ml_sub4: string;
  ml_sub5: string;
  add_player_id: number;
  player_id: string;
}

export interface Domain {
  name: string;
  value: string;
}

export type CodesModalLockerTypes = 'contentlocker' | 'captchalocker' | 'filelocker' | 'mobileRewards' | 'offerwall';

@Component({
  selector: 'app-codes-modal',
  templateUrl: './codes-modal.component.html',
  styleUrls: ['./codes-modal.component.scss'],
  providers: [CodesModalService]
})
export class CodesModalComponent implements OnInit {
  @Input() id: string = '';
  @Input() lockerType: CodesModalLockerTypes = 'contentlocker';

  public domains: Domain[] = [];

  public availableCodeOptions: AvailableCodeOption[] = [];

  public isLoaded = false;

  private requestParams: ICodesParams = {
    domain_id: 0,
    adblock_detection: 0,
    javascript_disabled_detection: 0,
    javascript_dynamic_options: 0,
    tracking_parameters: 0,
    auto_translation: 0,
    title: '',
    title_mobile: '',
    desc: '',
    desc_mobile: '',
    ml_sub1: '',
    ml_sub2: '',
    ml_sub3: '',
    ml_sub4: '',
    ml_sub5: '',
    add_player_id: 0,
    player_id: ''
  };

  public codes = {
    javascript_code: '',
    iframe_url: '',
    iframe_code: ''
  };

  public header = '';

  public get isOfferwall(): boolean {
    return this.lockerType === 'offerwall';
  }

  constructor(private readonly activeModal: NgbActiveModal, private readonly codesModalService: CodesModalService) {}

  ngOnInit(): void {
    this.availableCodeOptions = this.codesModalService.availableCodeOptions[this.lockerType];
    this.header = this.codesModalService.getModalHeader(this.lockerType);

    this.getDomains();
  }

  private getDomains(): void {
    if (!this.id) return;

    this.isLoaded = false;

    this.codesModalService.getDomains(this.id).subscribe(res => {
      if (res.data?.domains_list && res.data?.domains_list.length > 0) {
        this.requestParams.domain_id = res.data.domains_list[0].id ?? 0;

        this.domains = this.prepareDomains(res.data.domains_list);
      }

      this.getCodes();
    });
  }

  private prepareDomains(domainsArray: IDomain[]): { name: string; value: string }[] {
    const domainsList: Domain[] = [];
    for (const domain of domainsArray) {
      domainsList.push({ name: domain.name ?? '', value: domain.id?.toString() ?? '' });
    }
    return domainsList;
  }

  private getCodes(): void {
    if (!this.id) return;

    this.codesModalService.getLockerCodes(this.id, this.requestParams).subscribe(res => {
      if (res.domain_codes?.javascript_code) {
        this.codes.javascript_code = res.domain_codes.javascript_code;
      }
      if (res.domain_codes?.iframe_url) {
        this.codes.iframe_url = res.domain_codes.iframe_url;
      }
      if (res.domain_codes?.iframe_code) {
        this.codes.iframe_code = res.domain_codes.iframe_code;
      }
      this.isLoaded = true;
    });
  }

  public onSelectDomain($event: { domain: number }): void {
    this.requestParams.domain_id = $event.domain;

    this.getCodes();
  }

  public close(): void {
    this.activeModal.close();
  }

  public onCheckCodeOption($event: { index: string | number; checked: boolean; systemName: string }): void {
    this.availableCodeOptions[$event.index as number].checked = $event.checked;
    // @ts-ignore
    this.requestParams[$event.systemName] = $event.checked ? 1 : 0;
    if (!this.availableCodeOptions[$event.index as number].additionalTemplate) {
      this.getCodes();
    }
    if (!$event.checked) {
      this.availableCodeOptions[$event.index as number].additionalTemplateValues?.map(item => {
        item.value = '';
        // @ts-ignore
        this.requestParams[item.systemName as keyof ICodesParams] = '';
      });
      this.getCodes();
    }
  }

  public getParameterValue($event: { value: string; systemName: string; hasErrors: boolean }): void {
    // @ts-ignore
    this.requestParams[$event.systemName] = $event.value;
    this.getCodes();
  }
}
